module.exports = __webpack_public_path__ + "static/img/10.158aa90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/10.png
// module id = DpoU
// module chunks = 0